import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'enumKey',
	standalone: true
})
export class EnumKeyPipe implements PipeTransform {
	transform(value: number, data: object) {
		let text = '';
		Object.keys(data).forEach((key) => {
			if (data[key] === value) {
				text = key;
			}
		});
		return text;

	}
}
